<template>
  
    <div class="font-outfit ">
  
      <div class="my-7 flex justify-center  align-middle content-center items-center  cursor-pointer w-full">
        <router-link to="/"><img src="../assets/images/medremindLogoNew.png" alt="logo" class="mx-auto md:mr-3 w-3/6 md:w-full sm:h-8"></router-link>
      </div>
  
      <div>
        <h1  class="text-black text-2xl font-semibold font-outfit my-2"  > Request Password Reset</h1>
      </div>
  
      
      <div
        v-if="success"
        class=" border w-2/6 mx-auto bg-medalertBlue bg-opacity-10    text-black px-4 py-3 mt-4 rounded relative"
        role="alert">
  
            <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
            <span class="">{{ success }}</span>
        </div>
  
        <div
        v-if="error"
        class=" border w-2/6  mx-auto bg-red  text-white px-4 py-3 mt-4 rounded relative"
        role="alert">
  
            <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
            <span class="">{{ error }}</span>
        </div>
  
  
  
      <div class="bg-white text-black px-2 md:px-20 py-8 font-outfit flex flex-col justify-center mx-auto align-middle    content-center w-full md:w-2/4">
      
  
          <form class="w-full" @submit.prevent="handlePasswordResetRequest">
  
              
              <div class="flex flex-col text-start mx-11 mt-5 mb-2">
                  <label class="font-semibold text-base mb-4" for="">Enter the email you registered with</label>
                  <input v-model="email" required type="email"  class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                  bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Email address " >
              </div>
  
  
              <div class="mt-10 mx-11">
                  <button
                   :class="inactive ? 'cursor-not-allowed' : ''"
                   :disabled="inactive" type="submit" class="text-white disabled:bg-gray-200 bg-medalertBlue  hover:bg-blueHover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-lg w-full py-3 text-center mr-3 md:mr-0 dark:bg-purple dark:hover:bg-purple dark:focus:ring-purple font-outfit">Send
                  <!-- <span v-if="isLoading">
                    <Loading />
                  </span> -->
                  </button>
              </div>
          </form>
  
      </div>
  
    </div>
  
  </template>
  
  
  
  <script>
  
  import { ref } from 'vue'
  import Loading from "../components/Loading";
  import {useStore} from 'vuex'
  import {useRouter} from 'vue-router'
  import axios from 'axios';
  
  export default {
  
      components:{Loading},
  
      data(){
          return{
              showPassword:false
          }
      },
  
      setup() {
        
      const email = ref('')
      const error =ref('')
      const isLoading = ref(false);
      const success = ref('');

      const inactive = ref(false);
  
      const store = useStore()
      const router = useRouter()
  
  
  
      const handlePasswordResetRequest = async () => {
        try {
          inactive.value = true
        //   isLoading.value = true;
          const response = await axios.post(`/api/v1/account/forgot-password?email=${email.value}`)
          if (response){

            success.value = response.data.result.message ;
            
            (email.value = '')
            
  
            setTimeout(() => {
            success.value = '';
            inactive.value = false
            // isLoading.value = false;
            }, 3000);

          }    
        
        } catch(err) {
        //   isLoading.value = false;
          error.value = err.response.data.result.message
          console.log(error.value)
  
          setTimeout(() => {
            inactive.value = false
            error.value = '';
          }, 3000);
        }
  
      }
  
  
      return { 
      email,  
      error, 
      success,
      isLoading,
      inactive,
      handlePasswordResetRequest }
    }
  
  }
  
  </script>
  
  
  
  <style>
  
  </style>